export const environment = {
  production: false,
  baseUrl: 'https://api.dev.uvirtual.co',
  apiUrlV1: 'https://api.dev.uvirtual.co/api/v1'
};
